/**
 * Componente de campos personalizados
 */

import type { CustomField } from "../types";

interface CustomFieldsFormProps {
  fields: CustomField[];
  values: Record<string, any>;
  onChange: (values: Record<string, any>) => void;
}

export function CustomFieldsForm({ fields, values, onChange }: CustomFieldsFormProps) {
  if (fields.length === 0) return null;

  return (
    <div className="mt-6 rounded-2xl border border-slate-200 bg-slate-50/70 p-4">
      <h3 className="mb-3 text-base font-bold text-slate-950">Campos adicionais</h3>
      <div className="space-y-4">
        {fields.map((f) => (
          <div key={f.id} className="block">
            {f.type !== "checkbox" && (
              <label
                htmlFor={`custom-${f.id}`}
                className="mb-2 block text-sm font-bold text-slate-700"
              >
                {f.label} {f.required ? <span className="text-rose-500">*</span> : ""}
              </label>
            )}

            {f.type === "text" && (
              <input
                id={`custom-${f.id}`}
                className="h-11 w-full rounded-xl border border-slate-200 bg-white px-4 text-sm font-semibold text-slate-800 transition placeholder:text-slate-400 hover:border-primary-300 focus:border-primary-400 focus:outline-none focus:ring-4 focus:ring-primary-100"
                value={values[f.id] ?? ""}
                onChange={(e) => onChange({ ...values, [f.id]: e.target.value })}
                required={f.required}
              />
            )}

            {f.type === "textarea" && (
              <textarea
                id={`custom-${f.id}`}
                className="min-h-[96px] w-full resize-y rounded-xl border border-slate-200 bg-white px-4 py-3 text-sm font-semibold text-slate-800 transition placeholder:text-slate-400 hover:border-primary-300 focus:border-primary-400 focus:outline-none focus:ring-4 focus:ring-primary-100"
                value={values[f.id] ?? ""}
                onChange={(e) => onChange({ ...values, [f.id]: e.target.value })}
                required={f.required}
                rows={3}
              />
            )}

            {f.type === "select" && (
              <select
                id={`custom-${f.id}`}
                className="h-11 w-full rounded-xl border border-slate-200 bg-white px-4 text-sm font-semibold text-slate-800 transition hover:border-primary-300 focus:border-primary-400 focus:outline-none focus:ring-4 focus:ring-primary-100"
                value={values[f.id] ?? ""}
                onChange={(e) => onChange({ ...values, [f.id]: e.target.value })}
                required={f.required}
              >
                <option value="">Selecione...</option>
                {(f.options || []).map((opt) => (
                  <option key={opt} value={opt}>
                    {opt}
                  </option>
                ))}
              </select>
            )}

            {f.type === "checkbox" && (
              <label className="inline-flex items-start gap-3 rounded-xl border border-slate-200 bg-white px-3 py-3 text-sm font-semibold text-slate-700">
                <input
                  type="checkbox"
                  className="mt-0.5 h-4 w-4 rounded border-slate-300 text-primary-600 focus:ring-primary-500"
                  checked={!!values[f.id]}
                  onChange={(e) => onChange({ ...values, [f.id]: e.target.checked })}
                  required={f.required}
                />
                <span>
                  {f.label} {f.required ? <span className="text-rose-500">*</span> : ""}
                </span>
              </label>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
